import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccountEffects, PaymentEffects } from '@app/core/effects';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DomainComponent } from './domain/domain.component';
import { DomainEffects } from './domain/effects/domain.effects';
import { ModalDomainCreationProcessComponent } from './domain/modals/modal-domain-creation-process/modal-domain-creation-process.component';
import * as fromSignup from './reducers';
import { SignupComponent } from './signup.component';
import { SIGNUP_ROUTES } from './signup.routes';
import { SubscriptionEffects } from './subscription/effects/subscription.effects';
import { ModalSignupProcessComponent } from './subscription/modals/modal-signup-process/modal-signup-process.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SmashHeaderModule } from '@app/shared/modules/smash-header/smash-header.module';
import { SmashSignupFormModule } from '@app/shared/modules/smash-signup-form/smash-signup-form.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';

@NgModule({
  declarations: [
    SignupComponent,
    DomainComponent,
    SubscriptionComponent,
    ModalDomainCreationProcessComponent,
    ModalSignupProcessComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashHeaderModule,
    RouterModule.forChild(SIGNUP_ROUTES),
    ReactiveFormsModule,
    SmashSignupFormModule,
    SmashFormsModule,
    StoreModule.forFeature(fromSignup.signupFeatureKey, fromSignup.reducers),
    EffectsModule.forFeature([SubscriptionEffects, AccountEffects, PaymentEffects, DomainEffects]),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SignupModule { }
